<template>
    <section class="container-fluid">
      <div class="title-container">
        <h3 class="title">
          Skills
          <div
            v-if="isLoading"
            class="spinner-border spinner-theme_default"
            role="status"
          >
            <span class="sr-only" >
              Loading...
            </span>
          </div>
        </h3>
        <div class="title-container__controls">
          <b-button
            v-if="$can('create-skills')"
            class="button"
            variant="success"
            v-b-modal.modalSkill
          >
            Create
          </b-button>
        </div>
      </div>

      <b-modal
          id="modalSkill"
          ref="modal"
          @ok="createSkill"
          @hidden="resetModal"
      >
        <template v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">Skill</h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click.prevent="cancel"
          >
            <span class="material-icons">
              close
            </span>
          </button>
        </template>
          <b-form ref="form">
            <b-form-group
                    id="name"
                    label="Name:"
                    label-for="name"
                    invalid-feedback="Name is required"
            >
                <b-form-input
                        id="name"
                        type="text"
                        v-model="form.name"
                        required
                        :state="nameState"
                        placeholder="Enter name" />
            </b-form-group>
            <b-form-group
                    id="description"
                    label="Description:"
                    label-for="description"
            >
                <b-form-textarea
                        id="description"
                        v-model="form.description"
                        placeholder="Enter description..."
                        rows="3"
                        max-rows="6"
                ></b-form-textarea>
            </b-form-group>
            <b-form-group
                    id="icon"
                    label="Icon:"
                    label-for="icon"
            >
                <b-form-input
                        id="icon"
                        type="text"
                        v-model="form.icon"
                        placeholder="Enter url for icon" />
            </b-form-group>
          </b-form>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button
            variant="outline"
            class="button"
            @click.prevent="cancel"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="button"
            @click.prevent="ok"
          >
            Create
          </b-button>
        </template>
      </b-modal>

      <TableForPage
        style="margin-bottom: 0;"
        v-if="skills.length"
        :tableData="skills"
        :fields="fields"
        :slots="slots"
        :isEdit="$can('update_all-skills')"
        :isRemove="$can('delete-skills')"
        @edit="edit"
        @remove="deleteSkill"
      >
        <template v-slot:icon="data">
          <img v-if="data.item.icon" class="width-icon" :src='`${data.item.icon}`'/>
          <img v-else src="/images/skills/skill.png" class="width-icon" />
        </template>
      </TableForPage>

    </section>
</template>
<script>
import TableForPage from '@tables/TableForPage'

export default {
  name: 'skills',
  components: {
    TableForPage
  },
  data () {
    return {
      slots: {
        icon: {
          name: 'icon'
        }
      },
      fields: [
        {
          label: 'Skill',
          key: 'icon',
          sortable: false,
          class: 'column-skills-logo'
        },
        {
          label: 'Name',
          key: 'name',
          sortable: true,
          class: 'column-project-name'
        },
        {
          label: 'Description',
          key: 'description',
          sortable: true
        },
        {
          label: 'actions',
          key: 'actions',
          class: 'column_action'
        }
      ],
      skills: [],
      form: {
        id: '',
        name: '',
        description: '',
        icon: ''
      },
      nameState: null,
      isLoading: false
    }
  },
  methods: {
    deleteSkill (item) {
      this.isLoading = true
      this.axios.post(
        `/api/skill/delete/${item.id}`,
        {},
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        this.getSkills()
        this.$snotify.success(response.data, 'Success', this.$store.state.snotify)
      }).catch(err => {
        console.log(err)
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    resetModal () {
      this.form = {
        id: '',
        name: '',
        description: '',
        icon: ''
      }
      this.nameState = null
    },
    edit (skill) {
      this.form.id = skill.id
      this.form.name = skill.name
      this.form.description = skill.description
      this.form.icon = skill.icon
      this.$nextTick(() => {
        this.$refs.modal.show()
      })
    },
    createSkill (e) {
      e.preventDefault()
      // Trigger submit handler
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid ? 'valid' : 'invalid'
      if (!valid) {
        return
      }
      var url = ''
      var flag = ''
      if (this.form.id > 0) {
        url = `/api/skill/update/${this.form.id}`
        flag = 'updated'
      } else {
        url = '/api/skill/create'
        flag = 'created'
      }

      if (this.form.icon.length === 0) {
        delete this.form.icon
      }

      this.isLoading = true
      this.axios.post(
        url,
        this.form,
        {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        }).then(response => {
        if (response.status === 200) {
          this.getSkills()
          this.$snotify.success('Skill successfully ' + flag, 'Success', this.$store.state.snotify)
        }
        this.$nextTick(() => {
          this.$refs.modal.hide()
        })
        this.resetModal()
      }).catch(err => {
        console.log(err)
        var errors = Object.values(err.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    getSkills () {
      this.isLoading = true
      this.axios({
        method: 'get',
        url: '/api/skills',
        headers: {
          Authorization: 'Bearer' + localStorage.getItem('access_token')
        }
      }).then(response => {
        this.skills = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
      })
    }
  },

  mounted () {
    this.getSkills()
  }
}
</script>

<style>
    .table-skills {
        vertical-align: middle !important;
    }
    .width-icon {
        width: 70px;
    }
</style>
